"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMedia = exports.Overlay = exports.Text = exports.Content = exports.Title = exports.Breadcrumbs = exports.HeaderContainer = exports.Header = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const container_1 = __importDefault(require("../container"));
const media_1 = __importDefault(require("../media"));
const typography_1 = __importDefault(require("../typography"));
const PREFIX = "SpotlightHero";
exports.classes = {
    keyline: `${PREFIX}-keyline`,
    video: `${PREFIX}-video`,
    cyan: `${PREFIX}-cyan`,
    blue: `${PREFIX}-blue`,
    charcoal: `${PREFIX}-charcoal`,
    teal: `${PREFIX}-teal`,
    text: `${PREFIX}-text`,
    cta: `${PREFIX}-cta`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    position: "relative",
    [theme.breakpoints.up("sm")]: {
        height: "630px"
    },
    [`&.${exports.classes.keyline}`]: {
        borderBottom: `8px solid ${theme.colours.accent}`
    },
    [`.${exports.classes.video}`]: {
        position: "absolute",
        top: 0
    },
    [`.${exports.classes.cyan}`]: {
        "&::after": {
            backgroundColor: theme.colours.cyan700
        }
    },
    [`.${exports.classes.blue}`]: {
        "&::after": {
            backgroundColor: theme.colours.blue900
        }
    },
    [`.${exports.classes.charcoal}`]: {
        "&::after": {
            backgroundColor: theme.colours.charcoal
        }
    },
    [`.${exports.classes.teal}`]: {
        "&::after": {
            backgroundColor: theme.colours.teal500
        }
    },
    [`.${exports.classes.cta}`]: {
        marginTop: "24px",
        display: "block",
        width: "fit-content"
    }
}));
exports.Header = (0, styles_1.styled)("div")({
    position: "relative",
    zIndex: 1,
    backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))",
    width: "100%"
});
exports.HeaderContainer = (0, styles_1.styled)(container_1.default)(({ theme }) => ({
    minHeight: "unset",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
        minHeight: "200px"
    }
}));
exports.Breadcrumbs = (0, styles_1.styled)("div")({ marginTop: "24px" });
exports.Title = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    position: "relative",
    zIndex: 2,
    color: theme.colours.white,
    marginTop: "24px",
    [theme.breakpoints.up("sm")]: {
        marginTop: "auto"
    }
}));
exports.Content = (0, styles_1.styled)("div")(({ theme }) => ({
    position: "relative",
    zIndex: 1,
    color: theme.colours.white,
    maxWidth: "600px",
    paddingBottom: "40px",
    [theme.breakpoints.up("sm")]: {
        marginBottom: "auto"
    }
}));
exports.Text = (0, styles_1.styled)("div")({
    minHeight: "auto",
    width: "100%",
    overflow: "hidden",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical"
});
exports.Overlay = (0, styles_1.styled)("div")({
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    zIndex: 0,
    "&::after": {
        content: "''",
        position: "absolute",
        zIndex: 1,
        height: "100%",
        width: "100%",
        opacity: 0.8,
        top: 0,
        left: 0
    }
});
exports.StyledMedia = (0, styles_1.styled)(media_1.default)({
    width: "100%",
    height: "100%",
    position: "relative",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
});
//# sourceMappingURL=data:application/json;base64,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